import { AlertTitle } from "@mui/material"
import { ReactElement } from "react"

import { STATUS_METADATA_DISPATCHER } from "./statusMetadataDispatcher"
import { UNKNOWN_STATUS } from "../../../constants/generalConstants"
import AppAlert from "../../dataDisplay/alerts/appAlert"

interface StatusAlertProps {
    status: string
}

/**
 * Returns alert for generic application statuses. Status must be defined
 * in `./statusMetadataDispatcher.ts`. The configs in this dispatcher are
 * referenced via the status keyword.

 * @example
 * <StatusAlert status="Compliant" />
 */
const StatusAlert = ({ status }: StatusAlertProps): ReactElement => (
    <AppAlert
        severity={
            STATUS_METADATA_DISPATCHER[status].alertSeverity ||
            STATUS_METADATA_DISPATCHER[UNKNOWN_STATUS].alertSeverity
        }
    >
        <AlertTitle>{status}</AlertTitle>
        {STATUS_METADATA_DISPATCHER[status].alertMessage ||
            STATUS_METADATA_DISPATCHER[UNKNOWN_STATUS].alertMessage}
    </AppAlert>
)

export default StatusAlert
